import { render, staticRenderFns } from "./editRental.vue?vue&type=template&id=fb8b6ad8&scoped=true&"
import script from "./editRental.vue?vue&type=script&lang=js&"
export * from "./editRental.vue?vue&type=script&lang=js&"
import style0 from "./editRental.vue?vue&type=style&index=0&id=fb8b6ad8&scoped=true&lang=scss&"
import style1 from "./editRental.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8b6ad8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDivider,VForm,VSelect,VTextField})
